<template>
  <v-layout column>
    <v-flex xs12>
      <!-- Filtros -->
      <v-card v-if="filtros" class="mb-4">
        <v-toolbar dense color="grey lighten-2">
          <v-toolbar-title class="title">Filtros</v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat icon @click="filtros = false" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          
          <v-tooltip bottom>
            <v-btn fab dark small color="primary" icon @click="aplicaFiltros" slot="activator">
              <v-icon>done</v-icon>
            </v-btn>
            <span>Aplicar</span>
          </v-tooltip>
        </v-toolbar>
        <v-container fluid grid-list-xl>
          <v-layout row wrap>
            <v-flex xs12 md3>
              <v-select
                v-model="filtroSelected"
                :items="filtroProjetos"
                item-text="text"
                item-value="value"
                prepend-icon="description"
                label="Filtrar Projetos"
                no-data-text="Nenhum registro encontrado"
              ></v-select>
            </v-flex>
            <v-flex xs12 md3 v-if="filtroSelected == 'periodo'">
              <v-menu v-model="periodoDatepickerInicial" :close-on-content-click="false" full-width>
                <v-text-field readonly slot="activator"
                  :value="moment(periodo.dataInicial).format('DD/MM/YYYY')" label="Data Inicial" prepend-icon="event">
                </v-text-field>
                <v-date-picker @change="periodoDatepickerInicial = false" locale="pt" v-model="periodo.dataInicial"></v-date-picker>
              </v-menu>
              <v-menu v-model="periodoDatepickerFinal" :close-on-content-click="false" full-width>
                <v-text-field readonly slot="activator"
                  :value="moment(periodo.dataFinal).format('DD/MM/YYYY')" label="Data Final" prepend-icon="event">
                </v-text-field>
                <v-date-picker @change="periodoDatepickerFinal = false" locale="pt" v-model="periodo.dataFinal"></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 md3>
              <v-select
                v-model="statusSelected"
                item-text="Descricao"
                return-object
                :items="JSON.parse(layoutSelected.Configuracoes).statusSelected"
                label="Filtrar Status"
                prepend-icon="description"
                no-data-text="Nenhum registro encontrado"
                multiple
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
    <v-flex xs12>
      <div :class="filtros ? '' : 'pos-abs-fixed'">
        <v-toolbar 
          color="grey lighten-2"
          dense
        >
          <!-- <v-toolbar-title class="title">{{ pageTitle }}</v-toolbar-title> -->
          <v-flex md3>
            <v-select
              v-model="layoutSelected"
              :items="layoutsSql"
              item-text="Titulo"
              return-object
              no-data-text="Nenhum registro encontrado"
              @change="changeLayoutSql"
            ></v-select>
          </v-flex>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <div v-if="$vuetify.breakpoint.mdAndUp">
            <v-chip v-for="status in statusSelected" :key="status" dark :color="statusProjeto(status)">{{ status[0] }}</v-chip>
          </div>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <v-flex md2>
            <span 
              v-if="this.filtroSelected === 'periodo' && $vuetify.breakpoint.mdAndUp"
              class="font-weight-bold"
            >
              <v-icon small>event</v-icon> {{ periodoSelected }}
            </span>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex v-if="gridSelected === 'coluna'" xs2>
            <v-select
              v-model="searchField"
              :items="computedHeaders"
              item-text="text"
              item-value="value"
            ></v-select>
          </v-flex>
          <v-flex xs4 px-3 v-if="$vuetify.breakpoint.mdAndUp">
            <v-text-field prepend-inner-icon="search" clearable v-model="searchTerm"></v-text-field>
          </v-flex>
          <v-tooltip bottom>
            <ModalCadastroProjeto slot="activator" />
            <span>Adicionar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn 
              @click="alteraGrid"
              flat 
              icon 
              small 
              slot="activator">
              <v-icon>{{ iconGridSelected }}</v-icon>
            </v-btn>
            <span>{{ tooltipGridSelected }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn flat icon small slot="activator" @click="aplicaFiltros" :loading="loading">
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Atualizar</span>
          </v-tooltip>
          <v-tooltip bottom v-if="gridSelected === 'lista'">
            <span>Opções</span>
            <v-menu bottom left slot="activator">
              <v-btn flat icon small slot="activator">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  @click="editItemSelected"
                >
                  <v-list-tile-title>
                    <v-icon small class="pr-1">edit</v-icon>
                      Alterar
                    </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click='$emit("deleteItemSelected")' class="cursor-pointer">
                  <v-list-tile-title>
                    <v-icon small class="pr-1">delete</v-icon>Excluir
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click='$emit("finalizaItemSelected")' class="cursor-pointer">
                  <v-list-tile-title>
                    <v-icon small class="pr-1">check</v-icon>Finalizar
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile class="cursor-pointer">
                  <v-list-tile-title @click='$emit("abreModalDuplicaProjeto", null)'>
                    <v-icon small class="pr-1">event</v-icon>Duplicar Projeto
                  </v-list-tile-title>
                </v-list-tile>
                <!-- <v-list-tile class="cursor-pointer">
                  <v-list-tile-title @click='$emit("abreModalEditPrevisao", null)'>
                    <v-icon small class="pr-1">event</v-icon>Setar Previsão
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile class="cursor-pointer">
                  <v-list-tile-title @click='$emit("abreModalEditSituacao", null)'>
                    <v-icon small class="pr-1">description</v-icon>Setar Situação
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile class="cursor-pointer">
                  <v-list-tile-title @click='$emit("abreModalEditResponsavel", null)'>
                    <v-icon small class="pr-1">person</v-icon>Setar Responsável
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile class="cursor-pointer">
                  <v-list-tile-title @click='$emit("abreModalEditTipoAtividade", null)'>
                    <v-icon small class="pr-1">label_important</v-icon>Setar Tipo Atividade
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile class="cursor-pointer">
                  <v-list-tile-title @click='$emit("abreModalEditColaborador", null)'>
                    <v-icon small class="pr-1">group_add</v-icon>Setar Colaborador
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile class="cursor-pointer">
                  <v-list-tile-title @click='$emit("abreModalEditCliente", null)'>
                    <v-icon small class="pr-1">group_add</v-icon>Setar Cliente
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile class="cursor-pointer">
                  <v-list-tile-title @click='$emit("abreModalEditTag", null)'>
                    <v-icon small class="pr-1">label</v-icon>Setar Tag
                  </v-list-tile-title>
                </v-list-tile> -->
              </v-list>
            </v-menu>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn flat icon small slot="activator" @click="filtros = !filtros">
              <v-icon>filter_list</v-icon>
            </v-btn>
            <span>Filtros</span>
          </v-tooltip>
        </v-toolbar>
      </div>
      <!-- Visão em Grid -->
      <v-data-table
        v-if="gridSelected === 'lista'"
        v-model="selected"
        :headers="computedHeaders"
        :items="computedItems"
        :item-key="computedItemKey"
        rows-per-page-text="Registros"
        select-all
        :pagination.sync="defaultPagConfig"
        :loading="loading"
        :search="searchTerm"
        no-data-text="Nenhum registro encontrado"
      >
        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <tr
            :active="props.selected"
            class="cursor-pointer atividade"
            @dblclick="editItem(props.item.IdProjeto)"
            @click="props.selected = !props.selected"
          >
            <td>
              <v-checkbox :input-value="props.selected" primary color="primary" hide-details></v-checkbox>
            </td>
            <td v-for="(header, index) in headers" :key="index">
              <v-avatar v-if="header.value === 'Status'" size="32" :color="statusProjeto(props.item.Status)">
                <span class="white--text">{{ props.item.Status[0] }}</span>
              </v-avatar>
              <span v-if="header.value === 'DuracaoLimite'">
                {{ duracaoAtividade(props.item.DuracaoLimite) }}
              </span>
              <span v-if="header.value === 'DataPrevisao'">{{ moment.utc(props.item.DataPrevisao).format('DD/MM/YYYY') }}</span>
              <v-chip v-if="header.value === 'Situacao'" dark :color="props.item.Cor">{{ props.item.Situacao }}</v-chip>
              <!-- <v-progress-linear
                v-if="header.value === 'Progresso'"
                v-model="props.item.Progresso"
                height="20"
                :value="props.item.Progresso"
                :color="progressColor(props.item.Progresso)"
                class="text-xs-center"
              >{{ props.item.Progresso }}%</v-progress-linear> -->
              <v-progress-circular
                v-if="header.value === 'ValorGut'"
                :size="36"
                :value="props.item.ValorGut || 0"
                :color="matrizGutColor(props.item.ValorGut || 0)"
              >
                <span class="font-weight-medium">{{ props.item.ValorGut || 0 }}</span>
              </v-progress-circular>
              <span v-if="filtraHeaders(header)">{{ props.item[header.value] }}</span>
              <v-progress-circular
                v-if="header.value === 'ValorNps' && props.item.ValorNps !== null && props.item.ValorNps !== undefined"
                :size="36"
                :value="npsValue(props.item.ValorNps)"
                :color="npsColor(props.item.ValorNps)"
              >
                <span class="font-weight-medium">{{ props.item.ValorNps }}</span>
              </v-progress-circular>
            </td>
          </tr>
        </template>
        <template v-slot:no-results>
          <v-alert
            :value="true"
            color="error"
            icon="warning"
          >Pesquisa por "{{ searchTerm }}" não encontrou resultados.</v-alert>
        </template>
        <template
          v-slot:pageText="props"
        >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
      </v-data-table>
      <!-- Fim Visão em Grid -->
      <NewColumnProjetos 
        v-if="gridSelected === 'coluna'"
        :items="computedItems"
        :agrupadorItems="situacoesSelected" 
        :searchField="searchField"
        :searchTerm="searchTerm"
        @editItem="editItem"
        @emiteEvento="emiteEvento"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import ModalCadastroProjeto from '@/components/projeto/ModalCadastroProjeto';
import NewColumnProjetos from '@/components/projeto/NewColumnProjetos';
import { matrizGutHelper } from '@/utils/matrizGutHelper';
import { npsHelper } from '@/utils/npsHelper';

export default {
  props: ["headers", "items", "itemKey", "loading", "title"],
  name: "NewGridProjetos",
  components: {
    ModalCadastroProjeto,
    NewColumnProjetos
  },
  data: () => ({
    gridSelected: 'lista',
    situacoesSelected: [],
    tiposRecursoSelected: [],
    colaboradoresSelected: [],
    statusSelected: [],
    defaultHeaders: [
      { text: "ID", value: "Id" },
      { text: "Descrição", value: "Descricao" },
      { text: "Status", value: "Status" },
    ],
    customHeaders: ["DataPrevisao", "Duracao", "DuracaoLimite", "Situacao", "Progresso", "Status", "ValorGut", "ValorNps"],
    defaultPagConfig: {
      descending: true,
      page: 1,
      rowsPerPage: 10, // -1 for All"
      sortBy: "DataPrevisao"
    },
    filtroSelected: 'meus',
    filtroProjetos: [
      { text: 'Meus Projetos', value: 'meus' },
      { text: 'Período', value: 'periodo' }
    ],
    filtros: false,
    layoutSelected: null,
    searchField: 'Projeto',
    searchTerm: '',
    periodoDatepickerInicial: false,
    periodoDatepickerFinal: false,
    periodo: {
      dataInicial: new Date().toISOString().substr(0, 10),
      dataFinal: new Date().toISOString().substr(0, 10)
    },
  }),
  computed: {
    ...mapGetters(["user", "projetosSelected", "layoutsSql", "situacoesProjeto"]),
    computedItems() {
      return this.items.filter(item => this.statusSelected.map(status => status[0]).includes(item.Status.trim()));
    },
    computedHeaders() {
      return this.headers && this.headers.length ? this.defaultHeaders = this.headers : this.defaultHeaders;
    },
    computedSituacoes() {
      const situacoes = [];
      this.situacoesProjeto.filter(situacao => {
        JSON.parse(this.layoutSelected.Configuracoes).situacoesSelected.forEach(situacaoSelected => {
          if (situacao.IdSituacao == situacaoSelected) situacoes.push(situacao.Descricao);
        });
      });
      return situacoes;
    },
    computedItemKey() {
      return this.itemKey ? this.itemKey : 'Descricao';
    },
    pageTitle() {
      return this.title ? this.title : 'Título';
    },
    iconGridSelected() {
      return this.gridSelected === 'lista' ? 'view_column' : 'view_list';
    },
    tooltipGridSelected() {
      return this.gridSelected === 'lista' ? 'Exibir Coluna' : 'Exibir Lista';
    },
    periodoSelected() {
      const { dataInicial, dataFinal } = this.periodo;
      const dataInicialFormatada = this.moment(dataInicial).format('DD/MM/YYYY');
      const dataFinalFormatada = this.moment(dataFinal).format('DD/MM/YYYY');
      const periodoFormatado = `${dataInicialFormatada} à ${dataFinalFormatada}`

      return periodoFormatado;
    },
    selected: {
      // getter
      get: function () {
        return this.projetosSelected;
      },
      set: function (value) {
        this.selectProjetos(value);
      }
    }
  },
  methods: {
    ...mapActions([
      "selectProjetos",
      "fetchLayoutsSql",
      "fetchLayoutsSqlUsuario",
      "resetProjetosSelected",
    ]),
    ...mapMutations(["showNotification", "closeNotification"]),
    npsValue(valor) {
      return npsHelper.npsValue(valor);
    },
    npsColor(valor) {
      return npsHelper.npsColor(valor);
    },
    matrizGutColor(valor) {
      return matrizGutHelper.matrizGutColor(valor);
    },
    aplicaFiltros(atualizaPreferencias = true) {
      this.$emit('aplicaFiltros', {
        filtro: this.filtroSelected === 'periodo' ? this.filtroSelected : null,
        periodo: this.filtroSelected === 'periodo' ? this.periodo : null,
        status: this.statusSelected,
        searchTerm: this.searchTerm,
        atualiza: !(typeof atualizaPreferencias === 'boolean')
      });
      this.filtros = false;
      this.salvaConfigPesquisa();
    },
    // Filtra o cabecalho e verifica se é algum cabecalho personalizado que já está sendo mostrado
    filtraHeaders(header) {
      return !this.customHeaders.includes(header.value);
    },
    changeLayoutSql(obj) {
      this.$emit('changeLayoutSql', obj.IdLayoutSql);
      this.preparaFiltrosLayout();
      this.aplicaFiltros(false);
    },
    editItem(id) {
      this.salvaConfigPesquisa();
      this.$emit('atualizaPreferencias', {
        filtro: this.filtroSelected === 'periodo' ? this.filtroSelected : null,
        periodo: this.filtroSelected === 'periodo' ? this.periodo : null,
        status: this.statusSelected,
        searchTerm: this.searchTerm,
        atualiza: true
      });
      this.$router.push({ name: "altera projeto", params: { id } });
    },
    editItemSelected() {
      if (this.projetosSelected.length) {
        this.salvaConfigPesquisa();
        this.$emit('atualizaPreferencias', {
          filtro: this.filtroSelected === 'periodo' ? this.filtroSelected : null,
          periodo: this.filtroSelected === 'periodo' ? this.periodo : null,
          status: this.statusSelected,
          searchTerm: this.searchTerm,
          atualiza: true
        });
        let id = this.projetosSelected[this.projetosSelected.length - 1].IdProjeto;
        this.resetProjetosSelected();
        this.$router.push({ name: "altera projeto", params: { id } });
      } else {
        this.showNotification({
          text: "Selecione um projeto para alterar.", status: 'error'
        });
      }
    },
    progressColor(progresso) {
      if (progresso >= 0 && progresso <= 30) return "error";
      if (progresso >= 30 && progresso < 100) return "warning";
      if (progresso == 100) return "success";
    },
    statusProjeto(status) {
      status = status[0];
      if (status.includes('A')) return "#263238";
      if (status.includes('F')) return "#1976d2";
      if (status.includes('C')) return "#bdbdbd";
    },
    alteraGrid() {      
      this.gridSelected = this.gridSelected === 'lista' ? 'coluna' : 'lista';
    },
    duracaoAtividade(tempo) {
      // let inicio = this.moment([1899, 11, 30]);
      // Verifica se o ano da tempo é 1899 == ano padrão DELPHI
      // Caso não, estaremos usando o ano padrão JavaScript == 1970
      const anoDelphi = new Date(tempo).getFullYear() == 1899;
      let inicio = anoDelphi ? this.moment([1899, 11, 30]) : new Date(1970, 0, 1, 0, 0, 0);
      let final = tempo ? this.moment(tempo) : this.moment(new Date(1970, 0, 1, 0, 0, 0));
      // Pega a diferença entre as datas em millisegundos
      let ms = this.moment(final, 'DD/MM/YYYY HH:mm:ss').diff(this.moment(inicio, 'DD/MM/YYYY HH:mm:ss'));
      let duration = this.moment.duration(ms);
      let duracaoFinal = Math.floor(duration.asHours()) + this.moment(ms).format(":mm");
      return duracaoFinal;
    },
    salvaConfigPesquisa() {
      this.searchField ? localStorage.setItem("NewGridProjetosSearchField", this.searchField) : localStorage.setItem("NewGridProjetosSearchField", "Projeto");
      this.searchTerm ? localStorage.setItem("NewGridProjetosSearchTerm", this.searchTerm) : localStorage.setItem("NewGridProjetosSearchTerm", "");
      localStorage.setItem("NewGridProjetosDefaultPagConfig", JSON.stringify(this.defaultPagConfig));
      localStorage.setItem("layoutSelectedProjetos", this.layoutSelected.IdLayoutSql);
      localStorage.setItem('filtroSelectedProjetos', this.filtroSelected);
      localStorage.setItem('statusNewProjetos', JSON.stringify(this.statusSelected));
      localStorage.setItem('NewGridProjetosPeriodo', JSON.stringify(this.periodo));
      // localStorage.setItem('newProjetosGridSelected', this.gridSelected);
    },
    recuperaConfigPesquisa() {
      // Verifica se existe no localStorage o item pagConfig salvo anteriormente
      if (localStorage.getItem('NewGridProjetosDefaultPagConfig')) {
        this.defaultPagConfig = JSON.parse(localStorage.getItem('NewGridProjetosDefaultPagConfig'));
      }
      // Verifica se existe o campo pesquisado salvo anteriormente
      if (localStorage.getItem('NewGridProjetosSearchField')) {
        this.searchField = localStorage.getItem('NewGridProjetosSearchField');
      } else {
        this.searchField = 'Projeto';
      }
      // Verifica se existe o termo pesquisado salvo anteriormente
      if (localStorage.getItem('NewGridProjetosSearchTerm')) {
        this.searchTerm = localStorage.getItem('NewGridProjetosSearchTerm');
      } else {
        this.searchTerm = '';
      }

      if (localStorage.getItem('filtroSelectedProjetos')) {
        this.filtroSelected = localStorage.getItem('filtroSelectedProjetos');
        if (this.filtroSelected == 'periodo') {
          this.periodo = JSON.parse(localStorage.getItem('NewGridProjetosPeriodo'));
        }
      } else {
        this.filtroSelected = 'meus';
      }

      if (localStorage.getItem("layoutSelectedProjetos")) {
        const id = localStorage.getItem("layoutSelectedProjetos");
        this.layoutSelected = this.buscaIdUltimoLayoutsql(id);
        this.preparaFiltrosLayout();
      } else {
        this.buscaUltimoLayoutSql();
        this.preparaFiltrosLayout();
      }
    },
    preparaFiltrosLayout() {
      // Tipos
      // this.tiposRecursoSelected = JSON.parse(this.layoutSelected.Configuracoes).tiposRecursoSelected.map(tipo => tipo.Descricao);
      // this.situacoesSelected = JSON.parse(this.layoutSelected.Configuracoes).situacoesSelected.map(situacao => situacao.Descricao);
      // Situações
      this.situacoesSelected = JSON.parse(this.layoutSelected.Configuracoes).situacoesSelected;
      // Colaboradores
      // this.colaboradoresSelected = JSON.parse(this.layoutSelected.Configuracoes).colaboradoresSelected.map(colaborador => colaborador.Descricao);
      // Preferências
      if (this.layoutSelected.Preferencias) {
        // Filtro selecionado nas preferências do layout
        const filtroPreferencias = JSON.parse(this.layoutSelected.Preferencias).filtro;
        // Filtro Periodo
        if (filtroPreferencias === 'periodo') {
          const periodoPreferencias = JSON.parse(this.layoutSelected.Preferencias).periodo;
          this.periodo.dataInicial = periodoPreferencias.dataInicial
          this.periodo.dataFinal = periodoPreferencias.dataFinal
        }
        this.filtroSelected = filtroPreferencias || 'meus';

        // Status selecionados nas preferências do layout
        const statusPreferencias = JSON.parse(this.layoutSelected.Preferencias).status;
        this.statusSelected = statusPreferencias;
        // Termo de pesquisa salvo nas preferências do layout
        const termo = JSON.parse(this.layoutSelected.Preferencias).searchTerm || '';
        this.searchTerm = termo;
      } else {
        this.filtroSelected = 'meus';
        this.searchTerm = '';
        this.statusSelected = JSON.parse(this.layoutSelected.Configuracoes).statusSelected;
      }
      // Grid
      this.gridSelected = JSON.parse(this.layoutSelected.Configuracoes).tipoVisualizacao;
    },
    buscaUltimoLayoutSql() {
      this.layoutSelected = this.layoutsSql[this.layoutsSql.length - 1];
    },
    buscaIdUltimoLayoutsql(id) {
      return this.layoutsSql.filter(layout => layout.IdLayoutSql == id)[0];
    },
    async inicializaLayoutSql() {
      const layoutSql = this.buscaIdUltimoLayoutsql(this.layoutSelected.IdLayoutSql);
      this.changeLayoutSql(layoutSql);
    },
    // Emissão de eventos para o componente pai
    emiteEvento(payload) {
      this.$emit(payload.evento, payload.item);
    }
  },
  async created() {
    await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: 100003 });
    this.recuperaConfigPesquisa();
    this.inicializaLayoutSql();
  }
};
</script>

<style scoped>
.pos-abs-fixed {
  z-index: 5;
  position: relative;
  padding-bottom: 50px;
}
.pos-abs-fixed > :first-child {
  position: fixed;
}
.cursor-pointer {
  cursor: pointer;
}
</style>